export type RightSidebarMenuOption = {
  id: number;
  title: string;
  slug: string;
  icon: string;
  width: string;
};

type RightSidebarMenuVisibilityContext = {
  canViewChat: boolean;
  hasChatToken: boolean;
  isSuperAdmin: boolean;
};

export const RIGHT_SIDEBAR_MENU_OPTIONS: RightSidebarMenuOption[] = [
  {
    id: 1,
    title: 'Scheduler',
    slug: 'scheduler',
    icon: 'eva:calendar-fill',
    width: '80%',
  },
  {
    id: 2,
    title: 'Chat',
    slug: 'custom-chat',
    icon: 'eva:message-square-outline',
    width: '70%',
  },
  {
    id: 3,
    title: 'AI Monitor',
    slug: 'ai-monitor',
    icon: 'eva:activity-fill',
    width: '760px',
  },
];

export const shouldHideRightSidebarMenuOption = (
  slug: string,
  context: RightSidebarMenuVisibilityContext
) =>
  (slug === 'chat' && (!context.hasChatToken || !context.canViewChat)) ||
  (slug === 'custom-chat' && !context.canViewChat) ||
  (slug === 'ai-monitor' && !context.isSuperAdmin);

export const getRightSidebarMenuOptionId = (slug: string) =>
  RIGHT_SIDEBAR_MENU_OPTIONS.find((menuOption) => menuOption.slug === slug)
    ?.id ?? 0;
